"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOLSelectionCollection = void 0;
const react_1 = require("react");
const OLSelectionProvider_1 = require("./OLSelectionProvider");
function useOLSelectionCollection() {
    return react_1.useContext(OLSelectionProvider_1.OLSelectionCollectionContext);
}
exports.useOLSelectionCollection = useOLSelectionCollection;
//# sourceMappingURL=useOLSelectionCollection.js.map